import axios from "axios";
import { useState } from "react";
import { useNavigate } from "react-router-dom";


export default function SupportMain() {

    const navigate = useNavigate();

    const [username, setUsername] = useState('');
    const [chatId, setChatId] = useState('');
    const [keyInput, setKeyInput] = useState("");


    const searchUser = async () => {
        let cleanedUsername = username;
        if (cleanedUsername.includes('@')) {
            cleanedUsername = cleanedUsername.replace('@', '');
        }

        cleanedUsername = cleanedUsername.trim();

        const data = { username: cleanedUsername }
        console.log({ data });
        const requestURL = "https://ger.wa.48.defaultbot.com/v4/get-id-by-username";
        const request = await axios.post(requestURL, data);
        console.log({ request });
        const { ok, id } = request.data;

        if (!ok) {
            alert("User not found");
        } else {
            navigate('/user/' + id);
        }
    }

    const validateUserKey = (event) => {
        if (event.target.value === '') {
            return;
        }
        let key = String(event.target.value);
        let keyId = '';

        if (String(key).includes('?q=')) {
            const array = key.split('?q=');
            key = array[0];
        }


        if (String(key).includes('https://shared.simplesmm.org/')) {
            const validKey = String(key);
            keyId = validKey.split('https://shared.simplesmm.org/')[1];
            navigate(`/switch/${keyId}`)
        }

        if (String(key).includes('https://key.simplesmm.org/')) {
            const validKey = String(key);
            keyId = validKey.split('https://key.simplesmm.org/')[1];
            navigate(`/switch/${keyId}`)
        }

        if (String(key).includes('https://key.simplesmm.org/')) {
            const validKey = String(key);
            keyId = validKey.split('https://key.simplesmm.org/')[1];
            navigate(`/switch/${keyId}`)
        }

        if (String(key).includes('https://bot.simplesmm.org/')) {
            const validKey = String(key);
            keyId = validKey.split('https://bot.simplesmm.org/')[1];
            navigate(`/switch/${keyId}`)
        }

        if (String(key).includes("https://config.x.simplesmm.org/")) {
            const validKey = String(key);
            keyId = validKey.split('https://config.x.simplesmm.org/')[1];
            navigate(`/switch/${keyId}`)
        }

        if (String(key).includes("https://key.simpletg.org/")) {
            const validKey = String(key);
            keyId = validKey.split('https://key.simpletg.org/')[1];
            navigate(`/switch/${keyId}`)
        }

        if (String(key).includes("https://conf.simpletg.org/")) {
            const validKey = String(key);
            keyId = validKey.split('https://conf.simpletg.org/')[1];
            navigate(`/switch/${keyId}`)
        }

        if (String(key).includes("https://tavukdurum.simplebotpro.ru/")) {
            const validKey = String(key);
            keyId = validKey.split('https://tavukdurum.simplebotpro.ru/')[1];
            navigate(`/switch/${keyId}`)
        }
    };

    return (
        <div className="content-block t-container">
            <div className="t-content">
                <div className="page-header"><h1>🥰 Support 🥰</h1></div>

                <div className="page-header">
                    <h2>Key Search</h2></div>
                <input
                    value={keyInput}
                    placeholder="https://key.simplesmm.org/XXXX OR bot.simplesmm.org"
                    onChange={validateUserKey}
                    type="text"
                    className="t-input"
                ></input>
                <button
                    className="t-button"
                    onClick={(e) => {
                        e.preventDefault();
                    }}
                >
                    Найти ключ
                </button>



                <div className="page-header">
                    <h2>Username Search</h2></div>
                <input
                    value={username}
                    placeholder="@username"
                    onChange={e => setUsername(e.target.value)}
                    type="text"
                    className="t-input"
                ></input>
                <button
                    className="t-button"
                    onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        searchUser();
                    }}
                >
                    Найти пользователя
                </button>

                <div className="page-header">
                    <h2>ChatID Search</h2></div>
                <input
                    value={chatId}
                    placeholder="Chat_ID"
                    onChange={e => setChatId(e.target.value)}
                    type="text"
                    className="t-input"
                ></input>
                <button
                    className="t-button"
                    onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        window.location = '/user/' + chatId;
                    }}
                >
                    Найти пользователя
                </button>
            </div>
        </div>
    )
}